import styled from 'styled-components';

export const InfoWrapper = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 0 auto 30px;
  padding: 0;
`;

export const InfoContent = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 768px) {
    padding-top: 20px;
  }
`;

export const StoreInfoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;
  margin-top: 0;

  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

export const StoreName = styled.h3`
  font-size: 2rem;
  font-weight: 800;
  margin: 0;
  color: oklch(0.2264 0 0);

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const StatusLabel = styled.label<{ $isOpen?: boolean }>`
  background-color: ${props => props.$isOpen ? 'var(--green-status, oklch(73.31% 0.198 142.15))' : 'oklch(0.61 0.25 28.5)'};
  color: oklch(1 0 0);
  padding: 4px 16px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 0.875rem;
  box-shadow: 0 4px 15px ${props => props.$isOpen ? 'oklch(73.31% 0.198 142.15 / 0.3)' : 'oklch(0.61 0.25 28.5 / 0.3)'};
`;

export const StoreMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 15px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
`;

export const StoreHours = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const HoursLabel = styled.span`
  font-size: 0.8125rem;
  color: oklch(0.5693 0 0);
  font-weight: 400;
`;

export const HoursValues = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3125rem;
  font-weight: 400;
  font-size: 0.9375rem;
  color: oklch(0.2264 0 0);
`;

export const DeliveryNote = styled.p`
  font-size: 0.75rem;
  color: oklch(0.683 0 0);
  margin: 5px 0 0 0;
  font-weight: 400;
  line-height: 1.4;
`;

export const BranchSelectorWrapper = styled.div`
  position: relative;
  
  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const InputContainer = styled.div`
  background: oklch(0.9842 0.0034 247.86);
  padding: 10px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  min-width: 150px;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  transition: all 0.2s;

  &:hover {
    background: oklch(0.9683 0.0069 247.9);
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const BranchText = styled.span`
  font-weight: 600;
  color: oklch(0.5103 0 0);
`;

export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: oklch(1 0 0);
  border-radius: 8px;
  box-shadow: 0 4px 20px oklch(0 0 0 / 0.1);
  margin-top: 8px;
  z-index: 100;
  overflow: hidden;
  border: 1px solid oklch(0.9288 0.0126 255.51);
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-5px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const DropdownItem = styled.div<{ $isSelected?: boolean; $isDisabled?: boolean }>`
  padding: 12px 20px;
  cursor: ${props => props.$isDisabled ? 'not-allowed' : 'pointer'};
  font-weight: ${props => props.$isSelected ? '700' : '500'};
  color: ${props => {
    if (props.$isDisabled) return 'oklch(0.683 0 0)';
    return props.$isSelected ? 'var(--primary-color, oklch(0.65 0.24 33.09))' : 'oklch(0.3211 0 0)';
  }};
  transition: background 0.2s;
  text-align: right;
  background: ${props => props.$isSelected ? 'oklch(0.9705 0.0129 17.38)' : 'transparent'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  opacity: ${props => props.$isDisabled ? '0.7' : '1'};

  &:hover {
    background: ${props => props.$isDisabled ? 'transparent' : 'oklch(0.9842 0.0034 247.86)'};
  }
  
  &:not(:last-child) {
    border-bottom: 1px solid oklch(0.9683 0.0069 247.9);
  }
`;

export const ComingSoonBadge = styled.span`
  font-size: 0.75rem;
  color: oklch(0.683 0 0);
  font-weight: 400;
  font-style: italic;
`;

// ==================== Skeleton Styles ====================

const shimmer = `
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const SkeletonBase = styled.div`
  ${shimmer}
  background: linear-gradient(
    90deg,
    oklch(0.9683 0.0069 247.9) 0%,
    oklch(0.9288 0.0126 255.51) 20%,
    oklch(0.9683 0.0069 247.9) 40%,
    oklch(0.9683 0.0069 247.9) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
  border-radius: 4px;
`;

export const SkeletonStoreName = styled(SkeletonBase)`
  width: 150px;
  height: 32px;
  border-radius: 6px;

  @media (max-width: 768px) {
    width: 120px;
    height: 24px;
  }
`;

export const SkeletonStatus = styled(SkeletonBase)`
  width: 60px;
  height: 28px;
  border-radius: 20px;
`;

export const SkeletonHoursLabel = styled(SkeletonBase)`
  width: 120px;
  height: 14px;
`;

export const SkeletonHoursValue = styled(SkeletonBase)`
  width: 200px;
  height: 16px;

  @media (max-width: 768px) {
    width: 180px;
  }
`;

export const SkeletonDeliveryNote = styled(SkeletonBase)`
  width: 250px;
  height: 12px;

  @media (max-width: 768px) {
    width: 220px;
  }
`;

export const SkeletonBranchSelector = styled(SkeletonBase)`
  width: 150px;
  height: 40px;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;
